import { createContext, useState } from "react";

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [hideCustomChat, setHideCustomChat] = useState(false);
  const [connectingToSF, setConnectingToSF] = useState(false);
  const [openChatWindow, setOpenChatWindow] = useState(false);

  return (
    <ChatContext.Provider
      value={{
        hideCustomChat,
        setHideCustomChat,
        connectingToSF,
        setConnectingToSF,
        openChatWindow,
        setOpenChatWindow,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
